<template>
  <v-main>
    <v-container
      fluid
      fill-height
      style="
        background-color: transparent;
        overflow-x: auto;
        white-space: nowrap;
      "
    >
      <v-layout column justify-start>
        <div style="display: flex; margin-left: 20px">
          <v-icon color="#05523E" size="50">mdi-view-dashboard</v-icon>
          <div style="font-size: 32px; font-weight: bold; margin-left: 10px">
            Dashboard
          </div>
        </div>
        <!-- search by date  -->
        <div
          style="
            display: flex;
            align-items: center;
            margin-left: 60px;
            height: 50px;
          "
        >
          <div style="font-size: 23px; font-weight: bold; width: 100px">
            Date
          </div>
          <div>
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  style="width: 125px"
                  append-icon="mdi-calendar"
                  v-model="startDate"
                  readonly
                  color="#05523E"
                  v-bind="attrs"
                  v-on="on"
                  v-on:change="dateValidation"
                />
              </template>
              <v-date-picker
                color="#05523E"
                v-model="startDate"
                v-on:change="dateValidation"
                @input="startDateMenu = false"
              />
            </v-menu>
          </div>

          <div style="margin-left: 2%">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  style="width: 125px"
                  append-icon="mdi-calendar"
                  v-model="endDate"
                  readonly
                  color="#05523E"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                color="#05523E"
                v-model="endDate"
                v-on:change="dateValidation"
                @input="endDateMenu = false"
              />
            </v-menu>
          </div>
        </div>

        <div style="margin-left: 55px">
          <!-- select part -->
          <v-btn-toggle
            v-model="selectColumn"
            v-on:change="ifAll"
            tile
            color="#D86C6C"
            group
          >
            <v-btn value="All"
              ><span style="font-weight: bold; font-size: 16px"
                >All</span
              ></v-btn
            >
            <v-btn value="Dept"
              ><span style="font-weight: bold; font-size: 16px"
                >Dept</span
              ></v-btn
            >
            <v-btn value="Product"
              ><span style="font-weight: bold; font-size: 16px"
                >Product</span
              ></v-btn
            >
            <v-btn value="Account"
              ><span style="font-weight: bold; font-size: 16px"
                >Account</span
              ></v-btn
            >
          </v-btn-toggle>
          <!-- search by department -->
          <div v-if="this.selectColumn == 'Dept'" style="margin-left: 19px">
            <v-select
              v-model="departmentColumn"
              label="All"
              @input="getChartbyDay"
              :items="$store.state.invoice.departments"
              item-text="name"
              item-value="value"
              style="max-width: 160px; min-width: 100px"
              single-line
              color="#05523E"
            />
          </div>
          <!-- select by product -->
          <div v-if="this.selectColumn == 'Product'">
            <v-btn
              class="elevation-2"
              style="
                color: #05523e;
                background-color: white;
                margin: 3px 10px;
                font-weight: bold;
              "
              @click="$store.commit('common/changeSearchProductModalView')"
              >Search Product</v-btn
            >
            <span style="color: #05523e; font-weight: 400">{{
              this.selectedProduct
            }}</span>
          </div>
          <div v-if="$store.state.common.searchProductModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.searchProductModalView"
              max-width="60%"
            >
              <SearchProductModal v-on:selectProduct="selectProduct" />
            </v-dialog>
          </div>
          <!-- select by account -->
          <div v-if="this.selectColumn == 'Account'">
            <v-btn
              class="elevation-2"
              style="
                color: #05523e;
                background-color: white;
                margin: 3px 10px;
                font-weight: bold;
              "
              @click="$store.commit('common/changeSearchAccountModalView')"
              >Search Account</v-btn
            >
            <span style="color: #05523e; font-weight: 400">{{
              this.selectedAccount
            }}</span>
          </div>
          <div v-if="$store.state.common.searchAccountModalView">
            <v-dialog
              class="rounded-lg"
              v-model="$store.state.common.searchAccountModalView"
              max-width="65%"
            >
              <SearchAccountModal v-on:selectAccount="selectAccount" />
            </v-dialog>
          </div>
        </div>
        <div v-show="isShow" style="margin-left: 55px; min-width: 600px">
          <LineChart v-if="isShow" />
          <div
            style="
              margin-top: 20px;
              overflow-x: auto;
              box-shadow: 1px 1px 2px 2px #cccccc;
              border-radius: 5px;
            "
          >
            <table style="min-width: 1024px">
              <thead>
                <th></th>
                <th
                  v-for="item in $store.state.dashboard.dashList"
                  v-bind:key="item.date"
                >
                  <div class="headTop">{{ item.date.substr(5, 10) }}</div>
                </th>
                <th style="font-size: 1.2rem"><b>Total</b></th>
              </thead>
              <tbody>
                <tr>
                  <th class="middleTh">Cost</th>
                  <td
                    v-for="item in $store.state.dashboard.dashList"
                    v-bind:key="item.date"
                  >
                    <div style="min-width: 50px">
                      {{ roundToTwo(item.cost) }}
                    </div>
                  </td>
                  <td>{{ roundToTwo($store.state.dashboard.total.cost) }}</td>
                </tr>
                <tr>
                  <th class="middleTh">Price</th>
                  <td
                    v-for="item in $store.state.dashboard.dashList"
                    v-bind:key="item.date"
                  >
                    {{ roundToTwo(item.price) }}
                  </td>
                  <td>{{ roundToTwo($store.state.dashboard.total.price) }}</td>
                </tr>
                <tr>
                  <th class="middleTh">Profit</th>
                  <td
                    v-for="item in $store.state.dashboard.dashList"
                    v-bind:key="item.date"
                  >
                    {{ roundToTwo(item.profit) }}
                  </td>
                  <td>{{ roundToTwo($store.state.dashboard.total.profit) }}</td>
                </tr>
                <tr>
                  <th class="middleTh">Profit(%)</th>
                  <td
                    v-for="item in $store.state.dashboard.dashList"
                    v-bind:key="item.date"
                  >
                    {{ item.pfPercent }}
                  </td>
                  <td>{{ $store.state.dashboard.total.pfPercent }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-show="!$store.state.common.isLoading && !isShow"
          style="font-size: 20px"
        >
          <div
            style="
              margin: 0% 0% 0% 500px;
              font-size: 40px;
              color: #05523e;
              font-weight: bold;
            "
          >
            No data was retrieved.
          </div>
          <img
            style="width: 700px; height: 600px; margin: 0% 0% 0% 300px"
            src="@/assets/noData.jpg"
          />
        </div>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import common from "@/util/common.js";
import SearchProductModal from "@/components/modal/SearchProductModal.vue";
import SearchAccountModal from "@/components/modal/SearchAccountModal.vue";
import LineChart from "@/components/Dashboard/Line.vue";
import { runGqlQuery } from "../graphql/gqlUtil";
import { GETDASHBOARD } from "@/graphql/InvoiceQueries.js";

export default {
  components: {
    SearchProductModal,
    SearchAccountModal,
    LineChart,
  },
  data() {
    return {
      header: this.$store.state.dashboard.dashList.map((data) => {
        return data.date;
      }),
      startDate: "",
      startDateMenu: false,
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDateMenu: false,
      selectColumn: "All",
      departmentColumn: "",
      selectedProduct: "",
      selectedAccount: "",
      itemNum: "",
      custNum: "",
      GroupBy: "",
      isShow: true,
    };
  },
  props: {
    source: String,
  },
  async created() {
    this.$store.commit("common/changeSelectedMenu", { selectedMenu: 0 });
    this.startDate = await common.calculateDate(this.endDate, -7);
    await this.$store.dispatch("invoice/getCategory");
    await this.getChartbyDay();
  },
  methods: {
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    typeMoney: (money) => {
      if (typeof money !== "number" && money === "0.0") {
        return money;
      } else if (0 <= money && money < 1000) {
        return money;
      } else if (money < 0 || 1000 <= money) {
        let ifMinus = false;

        if (money < 0) {
          ifMinus = true;
          money = Math.abs(money);
        }

        money += "";
        const sep = money.split(".");
        let result = "";

        for (let i = 1; i <= sep[0].length; i++) {
          result = sep[0][sep[0].length - i] + result;
          if (i % 3 === 0 && i !== sep[0].length) {
            result = "," + result;
          }
        }

        if (sep[1] !== undefined) result += "." + sep[1];
        if (ifMinus) result = "-" + result;

        return result;
      }
    },
    async dateValidation() {
      try {
        // 시작 날짜와 끝 날짜 같으면 시작 날짜 하루 빼기
        // if (this.startDate == this.endDate) {
        //   this.startDate = common.calculateDate(this.startDate, -1);
        // }
        // 시작 날짜가 끝 날짜 보다 늦으면
        if (new Date(this.endDate) - new Date(this.startDate) < 0) {
          this.startDate = await common.calculateDate(this.endDate, -1);
          await this.$store.commit("common/snackErrOn", {
            text: "The date was entered incorrectly.",
          });
        }
        this.getChartbyDay();
      } catch (e) {
        console.log(e);
      }
    },
    async selectProduct(itemNum, itemName) {
      try {
        this.selectedProduct = itemName;
        this.itemNum = itemNum;
        this.getChartbyDay();
      } catch (e) {
        console.log(e);
      }
    },
    async selectAccount(custNum, company) {
      try {
        this.selectedAccount = company;
        this.custNum = custNum;
        await this.getChartbyDay();
      } catch (e) {
        console.log(e);
      }
    },
    ifAll() {
      if (this.selectColumn === "All") {
        this.getChartbyDay();
      }
    },
    async getChartbyDay() {
      try {
        this.GroupBy = "";
        if (this.selectColumn === "All") {
          this.itemNum = "";
          this.custNum = "";
          this.departmentColumn = "";
          this.selectedProduct = "";
        } else if (this.selectColumn === "Dept") {
          this.itemNum = "";
          this.custNum = "";
          this.selectedAccount = "";
          this.selectedProduct = "";
          if (this.departmentColumn !== "") {
            this.GroupBy = "Dept_ID";
          }
        } else if (this.selectColumn === "Product") {
          this.selectedAccount = "";
          this.custNum = "";
          this.departmentColumn = "";
          if (this.itemNum) {
            this.GroupBy = "ItemNum";
          }
        } else if (this.selectColumn == "Account") {
          this.selectedProduct = "";
          this.itemNum = "";
          this.departmentColumn = "";
          if (this.itemNum) {
            this.GroupBy = "CustNum";
          }
        }

        this.isShow = false;

        const req = {
          StartDate: this.startDate,
          EndDate: this.endDate,
          Format: "yyyy-MM-dd",
          ItemNum: this.itemNum,
          Dept_ID: this.departmentColumn,
          CustNum: this.custNum,
          GroupBy: this.GroupBy,
        };

        const chartResult = await runGqlQuery(GETDASHBOARD, req);
        if (chartResult.message === undefined && chartResult.getDashboard[0]) {
          // 데이터 정리
          await this.$store.commit("dashboard/setChart", {
            getDashboard: chartResult.getDashboard,
            StartDate: this.startDate,
            EndDate: this.endDate,
          });
          this.isShow = true;
        } else {
          this.$store.state.dashboard.dashList = [];
          this.$store.state.dashboard.total = {};
          this.isShow = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  box-sizing: border-box;
}
table {
  border-collapse: collapse;
  overflow: auto;
  width: 100%;
}
th,
td {
  width: 100px;
  padding: 15px;
  text-align: left;
  vertical-align: middle;
}
tr,
thead {
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}
tr:hover {
  background-color: #eeeeee;
  opacity: 0.8;
}
.middleTh {
  font-size: 18px;
}
@media screen and (max-width: 1000px) {
  .user {
    display: none;
  }
}
</style>
